import React from "react";

export const PageLoader: React.FC = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="flex flex-col items-center gap-4">
                <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
                <p className="text-black">Loading...</p>
            </div>
        </div>
    );
};
